<template>
  <v-btn
    text
    :ripple="false"
    v-if="$attrs.validation == 'skin2019'"
    :style="$attrs.disabled == '' || $attrs.disabled == true ? { filter: 'grayscale(1)' } : ''"
    class="inheritCss"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="btn">
      <div class="mask">
        <div class="rect-left"></div>
        <div class="rect-top"></div>
        <span>
          <slot></slot>
        </span>
      </div>
    </div>
  </v-btn>
  <v-btn
    v-else
    :ripple="false"
    v-bind="$attrs"
    :color="$attrs.validation == '' || $attrs.validation == true ? 'primary' : $attrs.color"
    v-on="$listeners"
  >
    <span><slot></slot></span>
  </v-btn>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
button {
	&.v-btn {
		&.inheritCss {
			min-width: 0;
			height: inherit !important;
			font-size: inherit;
			will-change: inherit;
			margin: 0;
			text-transform: inherit;
			padding: 0 !important;
			min-width: inherit !important;
			& > span {
				&.v-btn__content {
					line-height: 1.9;
				}
			}
			&:before {
				display: none;
			}
		}
	}
}
div {
	&.btn {
		user-select: none;
		transition: transform 0.25s;
		margin: 0 0.8em;
		display: inline-block;
		box-shadow: 0 3px 1px -2px rgba(0,0,0,0.2), 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12);
		cursor: pointer;
		overflow: hidden;
		position: relative;
		border-radius: 0.2em;
		&.alt {
			text-align: center;
			color: #fff;
			&:hover {
				transform: scale(0.98);
			}
			& > div {
				&.mask {
					background: none;
				}
			}
		}
		&:active {
			transform: scale(0.95);
			transition: transform 0.1s;
		}
		div {
			&.rect-top {
				transform: rotate(-30deg);
				left: -30%;
				bottom: 140%;
				transition: 0.15s 0.25s;
			}
			&.rect-left {
				transform: rotate(-30deg);
				left: -50%;
				top: 20%;
				transition: 0.25s 0.05s;
			}
		}
		&:hover {
			div {
				&.rect-top {
					transform: rotate(-30deg);
					bottom: 60%;
					left: -10%;
				}
				&.rect-left {
					transform: rotate(-30deg);
					left: -24%;
					top: 0%;
				}
			}
		}
		& > div {
			&.mask {
				padding: 0.2em 1.6em;
				background: linear-gradient(309deg, #d13076 0%, #fc4a4a 53%, #bb1515 100%);
				position: relative;
				& > div {
					background-color: #bb1515;
					opacity: 0.5;
					position: absolute;
					&.pop {
						position: absolute;
						width: 1em;
						height: 1em;
					}
					&.rect-left {
						height: 150%;
						width: 40%;
					}
					&.rect-top {
						height: 130%;
						width: 70%;
					}
				}
				& > span {
					text-align: center;
					width: 100%;
					display: block;
					color: #fff;
					font-family: 'Cabin', sans-serif;
				}
			}
		}
	}
}
div.btn.alt > div.mask > div.rect-top,
div.btn.alt > div.mask > div.rect-left {
	display: none;
}

</style>
